export const applicationRoutes = {
  createAccount: '/crearunacuenta',
  createCoOwnerAccount: '/crearcopropietariocuenta',
  register: '/registro',
  eventManagement: '/gestiondeeventos(/:pageName/:eventID)',
  selectWhichMesaTableChoice: '/seleccionarcualmesacable',
  eventManagementIndexRoute: '/gestiondeeventos/EventManagementIndex(/:eventID)',
  maxEvents: '/crearevento/eventosmaximos',


  eventsMaxLimitReached: '/limitemaximodeeventoalcanzado', // ! REVIEW FUNCTIONALITY
  selectWhichMesa: '/crearevento/seleccioneWhichMesa', // ! REVIEW FUNCTIONALITY
  createEvent: '/crearevento', // ! ONLY FOR REDIRECT FUNCTIONALITY
  benefits: '/crearevento/beneficios', // ? Path of wap only

  // Celebrations /* CREATE EVENT FLOW*/}
  mesaType: '/crearevento/seleccioneeltipodemesa',

  openType: '/crearevento/seleccionetipo/eventoabierto',
  celebrationType: '/crearevento/seleccionetipo/celebraciones',

  createWedding: '/crearevento/boda',
  createBaby: '/crearevento/bebe',
  createXVYears: '/crearevento/dulcesquince',
  createFirst_communion: '/crearevento/Primeracomunion',  
  createBaptisms: '/crearevento/bautismo',
  createConfirmations: '/crearevento/confirmacion',
  createReligious: '/crearevento/otrasceremoniasreligiosas',
  createBar_Mitzvah: '/crearevento/barmitzvah',  
  createBat_Mitzvah: '/crearevento/batmitzvah',  
  // Open Events /* CREATE EVENT FLOW*/}
  createOpenHouse: '/crearevento/casaabierta',
  createMeetings: '/crearevento/reuniondelpartido',
  createChildrensParty: '/crearevento/fiestadeninos',
  createAniversary: '/crearevento/aniversario',
  createBirthday: '/crearevento/cumpleanos',
  createFarewell: '/crearevento/despedida',
  createOtras: '/crearevento/otros',
  createMascotas: '/crearevento/mascotas',

  addDeliveryAddress: '/crearevento/direcciondeentrega',


  // Browse and navigate
  home: '/',
  article: '/articulo',
  multipleEvents: '/eventosmultiples',
  notificationDetails: '/datosdeeventos/notificaciones(/:eventID/:profileId)',
  eventDetailsTipoDe: '/detallesdelevento/pagina/tipode',
  eventDetailsCelebrations: '/detallesdelevento/pagina/celebrations',
  eventStatusSuspendedForTime: '/eventoEstadoSuspendidoPorTiempo',
  // eventManagement
  // wapDatosDeMiEvento: '/gestiondeeventos/wapdatosdemievento', // TODO: Routing - unused

  // giftlist
  giftList: '/gestiondeeventos/listaderegalos(/:eventID)',
  predeterminedListsDetails: '/detallesdelistaspredeterminadas(/:eventID/:repoId)',
  predeterminedLists: '/listaspredeterminadas(/:eventType/:eventID)',
  // giftListGuestView: '/listadeinvitadosvistadeinvitados(/:eventID)',
  giftListGuestView: '/milistaderegalos(/:eventID)', // IBM defect 6630 change in route
  searchEvent: '/eventodebusqueda',
  giftTableList: '/eventodebusqueda/resultados',

  // Event Management Tools
  guestList: '/herramientasdeeventos/listadeinvitados(/:eventID)',
  myInvitation: '/herramientasdeeventos/miinvitacion(/:eventID)', // MY INVITATION -(Last page to display after saving template )
  invitationTemplate: '/herramientasdeeventos/plantillasdeinvitacion(/:eventID)', // STEP1
  toolsForMyEvent: '/herramientasdeeventos/herramientasparamievento(/:eventID)',
  newGuest: '/herramientasdeeventos/nuevoinvitado(/:eventID)',
  editGuest: '/herramientasdeeventos/editarinvitado(/:eventID)',
  sendReminder: '/herramientasdeeventos/enviarrecordatorio(/:eventID)',
  eventConfirmation: '/herramientasdeeventos/confirmaciondeevento(/:eventID)',
  importFromExcel: '/herramientasdeeventos/importardesdeexcel(/:eventID)',
  excelFeedData: '/herramientasdeeventos/datosdefeedexcel(/:eventID)',
  tableManagement: '/herramientasdeeventos/gestiondemesa(/:eventID)', // TODO: Routing - used in breadcrumb config
  downloadToPDF: '/descargareimprimir(/:pageName/:content/:fileName)',
  printData: '/descargareimprimir(/:pageName)', // New temp route for print needs to be removed later
  previewTemplate: '/herramientasdeeventos/plantilladevistaprevia(/:eventID)', // STEP1 (B)
  editInvitation: '/herramientasdeeventos/editarinvitacion(/:eventID)', // STEP 2
  viewGuestTemplate: '/herramientasdeeventos/verplantilladeinvitado(/:eventID)', // STEP 3
  notificationLanding: '/herramientasdeeventos(/:notificationType/:eventID/:isGuest/:id)', // Used in notification emails(s)
  toolsEvent: '/vistazoynavegar/herramientasparamievento', // TODO: #duplicate on line 77 (ToolsForMyEvent)
  importedguestList: '/herramientasdeeventos/listadeinvitadosimportada(/:eventID)',

  yahoo: '/auth/yahoo/callback',

  // Account Summary
  accountStatus: '/resumendelacuenta/estadodelacuenta(/:eventID)',
  electronicsGift: '/resumendelacuenta/regalodeelectronica(/:eventID)',
  physicalGifts: '/resumendelacuenta/regalosfisicos(/:eventID)',
  personalPurchases: '/resumendelacuenta/compraspersonales(/:eventID)',
  bonusDetails: '/resumendelacuenta/paginadedetallesdebonificacion(/:eventID)',
  accountsPartialTransfer: '/resumendelacuenta/transferenciaparcialdelacuenta(/:eventID)',
  partialTransference: '/resumendelacuenta/retiroanticipado(/:eventID)',
  partialConfirmation: '/resumendelacuenta/confirmaciondedeposito(/:eventID)',
  closureTransference: '/resumendelacuenta/cierre(/:eventID)',
  closureConfirmation: '/resumendelacuenta/cierreConfirmaciondedeposito(/:eventID)',
  downloadstatement: '/declaraciondedescarga',
  // END Account Summary

  healthcheck: '/healthcheck',
  instancecheck: '/instancecheck',
  template: '/modelo', // TODO: this would be removed in prod
  outlook: '/outlook',
  FlushCache: '/flushcache',
  DeleteCache: '/deletecache',

  // FAQ Page
  FAQPage: '/FrequentlyAskedQuestions',
};
